import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Field } from '@ontruck/orc';
import { useTranslation } from 'react-i18next';

const PasswordField = ({
  className,
  id,
  label,
  inputClass,
  size,
  value,
  onChange,
  error,
  ...rest
}) => {
  const { t } = useTranslation('AccountSettings');
  const [type, setType] = useState('password');

  const handleClick = useCallback(() => {
    setType(type === 'password' ? 'text' : 'password');
  }, [type]);

  return (
    <div className={className} data-testid="password-field">
      <div className="password-field" {...rest}>
        <Field
          id={id}
          label={label}
          name={id}
          className={inputClass}
          type={type}
          size={size}
          value={value}
          onChange={onChange}
          error={error}
        />
        <button
          className="password-field__action"
          onClick={handleClick}
          data-testid="password-field__action"
        >
          {type === 'password' ? t('show') : t('hide')}
        </button>
      </div>
    </div>
  );
};

PasswordField.defaultProps = {
  className: '',
  inputClass: '',
  size: 'M',
  error: false
};

PasswordField.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  inputClass: PropTypes.string,
  size: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool
};
export default PasswordField;
